"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.addressToKVHX = void 0;
const axios_1 = __importDefault(require("axios"));
const __1 = require("..");
const addressToKVHX = (address) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b;
    if (address.KVHX) {
        return address.KVHX;
    }
    const addressRes = yield axios_1.default
        .get(`https://api.dataforsyningen.dk/adresser?q=${encodeURIComponent((0, __1.addressToString)(address, {
        noCoAddress: true,
        noCountry: true,
    }))}`)
        .then((r) => r.data);
    if (addressRes && ((_a = addressRes[0]) === null || _a === void 0 ? void 0 : _a.kvhx)) {
        return addressRes[0].kvhx;
    }
    const addressWithFuzzySearchRes = yield axios_1.default
        .get(`https://api.dataforsyningen.dk/adresser?q=${encodeURIComponent((0, __1.addressToString)(address, {
        noCoAddress: true,
        noCountry: true,
    }))}&fuzzy=true`)
        .then((r) => r.data);
    return ((addressWithFuzzySearchRes && ((_b = addressWithFuzzySearchRes[0]) === null || _b === void 0 ? void 0 : _b.kvhx)) || null);
});
exports.addressToKVHX = addressToKVHX;
//# sourceMappingURL=index.js.map